// extracted by mini-css-extract-plugin
export default {"notification":"notification__notification--_r2SB"};